export const LEAD_STATUSES=[

    {

        value:"lead_received",

        label:"Lead Received"

    },

    {

        value:"called",

        label:"Called"

    },

    {

        value:"consent_taken",

        label:"Consent Taken"

    },

    {

        value:"punched_in",

        label:"Punched In"

    },

    {

        value:"in_progress",

        label:"In Progress"

    },

    {

        value:"approved",

        label:"Approved"

    },

    {

        value:"rejected",

        label:"Rejected"

    }

];